<script setup lang="ts">
useHead({
  htmlAttrs: {
    lang: 'en'
  },
  script: [
    {
      innerHTML: `
        (function(c,l,a,r,i,t,y){
            c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
            t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
            y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
        })(window, document, "clarity", "script", "rxuwxqvjuf");
      `
    }
  ]
});

useSeoMeta({
  title: 'Hunter Douglas UK'
});

const { isAuthenticated } = useAuth();
const route = useRoute();

// Show/hide the scrollbar when using the navigation menu based on one existing already.
watch(
  () => route.fullPath,
  async () => {
    nextTick().then(() => {
      const showScrollbar = document.body.clientHeight > window.innerHeight;

      if (showScrollbar && import.meta.client) {
        document?.body.classList.add('has-scrollbar');
      } else {
        document?.body.classList.remove('has-scrollbar');
      }
    });
  },
  {
    immediate: true
  }
);
</script>
<template>
  <NuxtLayout>
    <Toaster />
    <NuxtPage :page-key="route => route.fullPath" :keepalive="{ include: 'order-history' }" />
  </NuxtLayout>
</template>

<style>
body {
  overflow-x: hidden;
}

.has-scrollbar.no-scroll {
  position: fixed;
  width: 100%;
  overflow-y: scroll !important;
  pointer-events: all !important;
}

body.no-scroll {
  padding-right: 0 !important;
}

.page-enter-active,
.page-leave-active {
  transition:
    opacity 0.25s 0.05s cubic-bezier(0.39, 0.57, 0.56, 1),
    transform 0.55s cubic-bezier(0.39, 0.57, 0.56, 1);
}
.page-enter-from,
.page-leave-to {
  opacity: 0;
}
.page-enter-from {
  transform: translate3d(0, -0.15rem, 0);
}
</style>
